import { render } from "./NewConvert.vue?vue&type=template&id=36dc0f39&scoped=true"
import script from "./NewConvert.vue?vue&type=script&lang=js"
export * from "./NewConvert.vue?vue&type=script&lang=js"

import "./NewConvert.vue?vue&type=style&index=0&id=36dc0f39&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dc0f39"]])

export default __exports__